import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceNotesService {

  api_url = environment.url;

  constructor(private http: HttpClient) { }

  addNote(data:any){
    return this.http.post(`${this.api_url}service/note/add`, data);
  }
}
